import styled from "@emotion/styled";
import { MdsSkeleton } from "@/design-system/components/loader/MdsSkeleton";

export const TitleAndBadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[2]};
  padding: ${({ theme }) => theme.spacing[2]} 0;
`;

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing[2]};
`;

export const StyledSkeleton = styled(MdsSkeleton)<{ $width: string; $maxWidth: string }>`
  margin: 0;
  height: ${({ theme }) => theme.spacing[5]};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  width: ${({ $width: width }) => width};
  max-width: ${({ $maxWidth: maxWidth }) => maxWidth};
  background-color: ${({ theme }) => theme.colors.background.skeleton.bg};
  background-image: ${({ theme }) =>
    `linear-gradient(270deg, ${theme.colors.background.skeleton.ends} -6%, ${theme.colors.background.skeleton.middle} 15.88%, ${theme.colors.background.skeleton.ends} 37.33%)`};
`;
